<template>
  <div>
    <div class="top-sticky">
      <MenuUser />
    </div>
    <router-view />
  </div>
</template>
<script>
import MenuUser from "./components/menuUser/menuUser";
export default {
  components: {
    MenuUser,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
div.top-sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 1;
  /* box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1); */
  /* border-bottom: 1px solid #ddd; */
}
</style>
